module.exports = __webpack_public_path__ + "img/nav-public_request.3450177b.svg";